import { render, staticRenderFns } from "./EditSection.vue?vue&type=template&id=a55e245c&"
import script from "./EditSection.vue?vue&type=script&lang=js&"
export * from "./EditSection.vue?vue&type=script&lang=js&"
import style0 from "./EditSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports